import React, { createContext, useContext } from 'react'
import type { SafeWalletData, UndeployedSafe } from '../utils/types'
import type { ContractNetworks } from '../utils/contractNetworks'

export interface SafeAccountInfo {
  chainId: string
  safeAddress: string
  name: string
  deployed: boolean
  owners?: string[]
  threshold?: number
}

export interface SafeWalletContextType {
  safeWalletData: SafeWalletData
  setSafeWalletData: React.Dispatch<React.SetStateAction<SafeWalletData>>
  contractNetworks: ContractNetworks | undefined
  addSafe: (
    chainId: string,
    safeAddress: string,
    safeName: string,
    safeConfig?: UndeployedSafe,
    owners?: string[],
    threshold?: number
  ) => void
  removeSafe: (chainId: string, safeAddress: string, deployed?: boolean) => void
  setSafeMultiSendConfig: (
    chainId: string,
    safeAddress: string,
    multiSendAddress?: string,
    multiSendCallOnlyAddress?: string
  ) => void
  getSafeMultiSendConfig: (
    chainId: string,
    safeAddress: string
  ) =>
    | { multiSendAddress?: string; multiSendCallOnlyAddress?: string }
    | undefined
  getAllSafes: (filterByOwner?: string) => SafeAccountInfo[]
}

export const SafeWalletContext = createContext<
  SafeWalletContextType | undefined
>(undefined)

export function useSafeWalletContext() {
  const ctx = useContext(SafeWalletContext)
  if (!ctx)
    throw new Error(
      'useSafeWalletContext must be used within a SafeWalletProvider'
    )
  return ctx
}
